import { motion } from 'framer-motion';
import { openSplitScreenForSection, tryOpenAvatarWidget } from '../lib/avatarActions';
import { openManifestTopicPanel } from '../lib/manifestAvatarBridge';

interface ChipConfig {
  label: string;
  sectionId: string;
  prompt: string;
}

const CHIPS: ChipConfig[] = [
  { label: 'What is SELF Labs?', sectionId: 'self-labs', prompt: 'What is SELF Labs?' },
  { label: 'Who is Milan?', sectionId: 'milan-cheeks', prompt: 'Who is Milan Cheeks?' },
  { label: 'Show me SELF Phone', sectionId: 'self-phone', prompt: 'Show me SELF Phone' },
  { label: 'Explain SELF OS', sectionId: 'self-os', prompt: 'Explain SELF OS' },
  { label: 'What is Essence?', sectionId: 'essence', prompt: 'What is Essence?' },
  { label: 'What is Resonatia?', sectionId: 'resonatia', prompt: 'What is Resonatia?' },
  { label: 'Concierge 2.3', sectionId: 'role-model-ai', prompt: 'What is Concierge 2.3?' },
  { label: 'AuRA & Encoder', sectionId: 'aura-resonant-layer', prompt: 'What is AuRA Resonant Layer?' },
  { label: 'All Products', sectionId: 'products', prompt: 'Show me all SELF Labs products' },
  { label: 'Investor deck', sectionId: 'investors', prompt: 'Is SELF Labs raising? Show me the investor deck.' },
  { label: 'AI Incubator', sectionId: 'incubator', prompt: 'Tell me about the SELF Labs AI Incubator' },
  { label: 'AI Website Avatars', sectionId: 'ai-avatars', prompt: 'Tell me about AI website avatars' },
  { label: 'Cerebral OS', sectionId: 'bci', prompt: 'What is Cerebral OS?' },
  { label: 'Robotics & BCI', sectionId: 'robotics', prompt: 'Tell me about robotics and BCI at SELF Labs' },
  { label: 'Partner With SELF Labs', sectionId: 'partnerships', prompt: 'How can I partner with SELF Labs?' },
  { label: 'Living Website', sectionId: 'living-website', prompt: 'How can I get my own living website?' },
  { label: 'Build an app', sectionId: 'build', prompt: 'I want to build a mobile app — can I get a quote?' },
  { label: 'Book consultation', sectionId: 'consultation', prompt: 'I want to book a founder consultation with Milan' },
  { label: 'Request a Demo', sectionId: 'demo', prompt: 'I would like to request a demo' },
];

interface AvatarPromptChipsProps {
  className?: string;
  compact?: boolean;
}

export default function AvatarPromptChips({ className = '', compact = false }: AvatarPromptChipsProps) {
  const handleChip = (chip: ChipConfig) => {
    openSplitScreenForSection(chip.sectionId);
    tryOpenAvatarWidget(chip.prompt);
    openManifestTopicPanel(chip.sectionId);
  };

  return (
    <div className={`flex flex-wrap md:flex-wrap gap-2 overflow-x-auto pb-1 -mx-1 px-1 ${className}`}>
      {CHIPS.map((chip, i) => (
        <motion.button
          key={chip.sectionId}
          type="button"
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 + i * 0.04 }}
          onClick={() => handleChip(chip)}
          className={`flex-shrink-0 rounded-full
            bg-white/5 border border-white/12 text-white/85
            hover:bg-white/10 hover:border-white/22
            transition-all whitespace-nowrap
            ${compact ? 'text-xs px-2.5 py-1' : 'text-sm px-4 py-2'}`}
        >
          {chip.label}
        </motion.button>
      ))}
    </div>
  );
}
